// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class GetCruisePackageRequest extends ETagRequest {

    public cruisePackageId: string = "";

    public readonly isGetCruisePackageRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof GetCruisePackageRequest) || ((from as any).isGetCruisePackageRequest === true));
    }

    public static as(from?: object | null): GetCruisePackageRequest | null {
        return (GetCruisePackageRequest.is(from)) ? from as GetCruisePackageRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(GetCruisePackageRequest, "GetCruisePackageRequest");